export const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

/** First letter upper, rest lower. Empty string stays empty. */
export const toTitleCase = (str: string): string =>
  str.length === 0
    ? str
    : str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
